import { FunctionComponent } from "react";

export const NotFound: FunctionComponent = () => {
  return (
    <div>
      <p>Page Not Found</p>
    </div>
  );
};
